import { PropRef, useEffect, useMemo, useRef, useState } from 'preact/hooks'
import { useLocale } from '../../../../lib/intl/IntlProvider'
import { Geografi, Parti } from '../../../domain'
import { GrunndataSearch } from '../../shared/GrunndataSearch/GrunndataSearch'
import { ALLOWED_CHARS } from '../../../../lib/intl/helpers'

type UseSearch<T> = {
  clear: () => void
  query: string
  results: Array<T>
  ref: PropRef<HTMLInputElement>
}

export function useSearch(geografi: Geografi[], partier: Parti[]): UseSearch<Geografi | Parti> {
  const ref = useRef<HTMLInputElement>()

  const [query, setQuery] = useState('')
  const [results, setResults] = useState<any[]>(() => [])
  const locale = useLocale()

  const searcher = useMemo(() => new GrunndataSearch(geografi, partier, locale), [locale])

  useEffect(() => {
    const onFilter = async e => {
      e.preventDefault()
      const query = e.target.input.value
      const valid = ALLOWED_CHARS.test(query)
      const searchResults = await searcher.search(valid ? query : '')

      setQuery(query)
      if (searchResults.length > 5) {
        setResults([...searchResults.slice(0, 5)])
      } else {
        setResults(searchResults)
      }
    }

    if (ref.current) {
      ref.current.addEventListener('suggest.filter', onFilter)
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('suggest.filter', onFilter)
      }
    }
  }, [searcher])

  const clear = () => {
    if (ref.current) {
      const input = ref.current.querySelector('input') as HTMLInputElement
      input.value = ''
      input.focus()
    }
  }

  return { ref, query, results, clear }
}
